import React from 'react'

import BrandLogo from '~/assets/images/logo/brands'
import googlePlayTag from '~/assets/images/icons/ds/google-play-tag.svg'
import appleStoreTag from '~/assets/images/icons/ds/store-apple-tag.svg'
import configs from '~/env.json'
import { useSelector } from 'react-redux'

import { BRANCH_TYPES } from '~/helpers/constants'
import { Container, Flex, FloraButton, FloraTypography, Image } from '@grupoboticario/flora-react'

export default function ErrorCampaign() {
  const brandComponentsSettings = {
    BOT: {
      alt: 'Logo O Boticário',
      goToWebsiteButtonLabel: 'Acessar site O Boticário >',
      width: '250',
      height: '50'
    },
    QDB: {
      alt: 'Logo Quem Disse, Berenice?',
      goToWebsiteButtonLabel: 'Acessar site QDB >',
      width: '304',
      height: '48'
    },
    VULT: {
      alt: 'Logo Vult',
      goToWebsiteButtonLabel: 'Acessar site Vult >',
      width: '170',
      height: '48'
    },
    AUS: {
      alt: 'Logo Australian Gold',
      goToWebsiteButtonLabel: 'Acessar site Australian Gold >',
      width: '170',
      height: '110'
    }
  }

  const {
    campaignLockReasons,
    consumerMenu,
    layout: { CAMPANHA_ENCERRADA_TITULO, CAMPANHA_ENCERRADA_TEXTO } = {}
  } = useSelector((state) => state?.campaignReducers?.campaign)

  const branch = configs?.REACT_APP_BRANCH || 'BOT'
  const brandName = BRANCH_TYPES[branch]?.name || 'O Boticário'

  const consumerMenuRules = consumerMenu?.find((rule) => rule?.item === 'REGULAMENTO')

  const defaultTextCampaign = 'Você pode acessar o site para conferir novidades e aproveitar as promoções.'

  const shouldShowDefaultContent = !(CAMPANHA_ENCERRADA_TITULO || CAMPANHA_ENCERRADA_TEXTO)

  return (
    <Flex css={{ width: '100%', minHeight: '100vh' }} role='main' aria-labelledby='error-campaign-title'>
      <Container centerContent size='large' css={{ gap: '$23', justifyContent: 'center', maxWidth: '350px' }}>
        {CAMPANHA_ENCERRADA_TITULO && (
          <Flex>
            <FloraTypography as='h1' fontSize='title' id='error-campaign-title'>
              {CAMPANHA_ENCERRADA_TITULO}
            </FloraTypography>
          </Flex>
        )}
        {CAMPANHA_ENCERRADA_TEXTO && (
          <>
            <Flex>
              <FloraTypography as='p' fontSize='body1'>
                {CAMPANHA_ENCERRADA_TEXTO}
              </FloraTypography>
            </Flex>
            <Flex>
              <FloraTypography as='p' fontSize='body1'>
                {defaultTextCampaign}
              </FloraTypography>
            </Flex>
          </>
        )}
        {shouldShowDefaultContent && (
          <Flex direction='column' align='center' justify='center' css={{ width: '100%', gap: '$20' }}>
            <Flex>
              <BrandLogo
                width={brandComponentsSettings[branch].width}
                height={brandComponentsSettings[branch].height}
              />
            </Flex>
            <Flex direction='column' align='center' justify='center' css={{ gap: '$8', width: '100%' }}>
              <Flex>
                <FloraTypography as='h5' fontSize='title' css={{ textAlign: 'center' }}>
                  {campaignLockReasons?.[0] ||
                    'A plataforma não está disponível no momento. Tente novamente mais tarde.'}
                </FloraTypography>
              </Flex>
            </Flex>
          </Flex>
        )}

        <Flex direction='column' css={{ width: '100%', gap: '$6' }}>
          {consumerMenuRules?.link && (
            <Flex align='center' justify='center' css={{ width: '100%' }}>
              <FloraButton
                hierarchy='primary'
                size='large'
                surfaceColor='light'
                isFull
                as='a'
                href={consumerMenuRules?.link}
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Ver regulamento da campanha'
              >
                Ver regulamento
              </FloraButton>
            </Flex>
          )}

          <Flex align='center' justify='center' css={{ width: '100%' }}>
            <FloraButton
              hierarchy='primary'
              size='large'
              surfaceColor='light'
              isFull
              as='a'
              href={configs.REACT_APP_URL.replace(/h?campanha/, 'www')}
              target='_blank'
              rel='noopener noreferrer'
              aria-label={`Acessar o site da marca ${brandName}`}
            >
              {brandComponentsSettings[branch].goToWebsiteButtonLabel}
            </FloraButton>
          </Flex>
        </Flex>

        {brandName === 'O Boticário' && (
          <Flex direction='column' css={{ width: '100%' }}>
            <Flex justify='space-between'>
              <a
                href='https://play.google.com/store/apps/details?id=com.boticario.mobile'
                aria-label='Baixar o aplicativo O Boticário na Google Play'
              >
                <Image src={googlePlayTag} alt='Tag google play' />
              </a>
              <a href='https://apps.apple.com/br/app/o-botic%C3%A1rio/id978751089'>
                <Image
                  src={appleStoreTag}
                  alt='Tag apple store'
                  aria-label='Baixar o aplicativo O Boticário na App Store'
                />
              </a>
            </Flex>
          </Flex>
        )}
      </Container>
    </Flex>
  )
}
